<mat-tab-group  mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="OWNER">
    <app-enrollment-owner [enrollment]="enrollment"></app-enrollment-owner>
  </mat-tab>
  <mat-tab label="RENTAL PROPERTY">
    <app-enrollment-rental-property [property]="rental" [owners]="owners"></app-enrollment-rental-property>
  </mat-tab>
  <mat-tab label="RENTAL PROPERTY REPORTING">
    <app-enrollment-property-reporting [enrollment]="enrollment"></app-enrollment-property-reporting>
  </mat-tab>
  <mat-tab label="RENTAL PROPERTY LICENSES">
    <app-enrollment-property-licenses [license]="license"></app-enrollment-property-licenses>
  </mat-tab>
</mat-tab-group>
